export default function getTopLevelChapterIndex(state, ownProps) {
  if (!ownProps.chapterId) {
    return 0;
  }
  const topLevelChapterIds = state.story.topLevelChapters.map(({ id }) => id);

  // chapter is top level
  if (topLevelChapterIds.indexOf(ownProps.chapterId) !== -1) {
    return topLevelChapterIds.indexOf(ownProps.chapterId);
  }

  // chapter is subchapter
  const chapterSchema = state.story.chapters.find(
    (chapter) => chapter.id === ownProps.chapterId,
  ).schema;
  const chapterParentId =
    state.story.entities[chapterSchema][ownProps.chapterId].parent;
  if (topLevelChapterIds.indexOf(chapterParentId) !== -1) {
    return topLevelChapterIds.indexOf(chapterParentId);
  }

  return 0;
}
